<template>
  <div>
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>

    <div class="note-container" style="font-family: 'Poppins', sans-serif; overflow-y: auto;">
      <div class="create-order" style="min-width: 1200px;">
        <div class="left">
          <h3 class="order-type">Nueva Incidencia</h3>
        </div>
        <div class="right">
          <button type="button" @click="backIncidents">Volver</button>
        </div>
      </div>

      <div class="main-data-container" style="min-width: 1200px;">
        <div class="maintenance-main">
        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Información General</h4>
          </div>
          <div class="container-card-body">
            <div class="maintenance-general-grid">
              <div class="maintenance-column">
                <div class="form-input-group">
                  <label>Unidad:</label>
                  <select v-model="form.unit" :class="{ invalid: validationErrors.unit }">
                    <option value="">Seleccione</option>
                    <option v-for="u in units" :key="u.unit_id" :value="u.id">
                      {{ u.unit_short_id }} - {{ u.unit_plates }}
                    </option>
                  </select>
                </div>
                <div class="form-input-group">
                  <label>Empresa:</label>
                  <select v-model="form.company">
                    <option value="">Seleccione</option>
                    <option v-for="owner in owners" :key="owner.id" :value="owner.id">
                      {{ owner.owner }}
                    </option>
                  </select>
                </div>
                <div class="form-input-group">
                  <label>Operador:</label>
                  <select v-model="form.operator">
                    <option value="">Seleccione</option>
                    <option v-for="emp in operatorEmployees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>
                <div class="form-input-group">
                  <label>Dirección:</label>
                  <input type="text" v-model="form.incident_address" />
                </div>
                <div class="form-input-group">
                  <label>No. Orden Reparación:</label>
                  <input type="text" v-model="form.repair_order_number" />
                </div>
              </div>

              <div class="maintenance-column">
                <div class="form-input-group">
                  <label>Tipo de accidente:</label>
                  <input type="text" v-model="form.accident_type" />
                </div>
                <div class="form-input-group">
                  <label>División:</label>
                  <input type="text" v-model="form.division" />
                </div>
                <div class="form-input-group">
                  <label>Quién pagó:</label>
                  <input type="text" v-model="form.who_paid" />
                </div>
                <div class="form-input-group">
                  <label>Vo. Bueno:</label>
                  <select v-model="form.signed_off_by">
                    <option value="">Seleccione</option>
                    <option v-for="emp in employees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-input-group full-width">
              <label>Descripción:</label>
              <textarea v-model="form.accident_description" :class="{ invalid: validationErrors.accident_description }"></textarea>
            </div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Persona afectada</h4>
          </div>
          <div class="container-card-body">
            <div class="form-input-group full-width">
              <label>Nombre:</label>
              <input type="text" v-model="form.affected_person_name" />
            </div>
            <div class="form-input-group full-width">
              <label>Teléfono:</label>
              <input type="text" v-model="form.affected_person_phone" />
            </div>
            <div class="form-input-group full-width">
              <label>Email:</label>
              <input type="text" v-model="form.affected_person_email" />
            </div>
            <div class="form-input-group full-width">
              <label>Dirección:</label>
              <input type="text" v-model="form.affected_person_address" />
            </div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Autoridades involucradas</h4>
            <button type="button" class="mini-action" @click="addAuthority">Agregar</button>
          </div>
          <div class="container-card-body">
            <div v-for="(authority, index) in authorities" :key="`authority-${index}`" class="list-row">
              <div class="form-input-group">
                <label>Autoridad:</label>
                <input type="text" v-model="authority.authority" />
              </div>
              <div class="form-input-group">
                <label>Comentarios:</label>
                <input type="text" v-model="authority.comments" />
              </div>
              <button type="button" class="mini-delete" @click="removeAuthority(index)">✕</button>
            </div>
            <div v-if="!authorities.length" class="empty-row">No hay autoridades registradas.</div>
          </div>
        </div>

        <div class="container-card">
          <div class="title maintenance-title-row">
            <h4>Daños reportados</h4>
            <button type="button" class="mini-action" @click="addDamage">Agregar</button>
          </div>
          <div class="container-card-body">
            <div v-for="(damage, index) in damagesList" :key="`damage-${index}`" class="list-row">
              <div class="form-input-group">
                <label>Tipo:</label>
                <input type="text" v-model="damage.type" />
              </div>
              <div class="form-input-group">
                <label>Comentarios:</label>
                <input type="text" v-model="damage.comments" />
              </div>
              <button type="button" class="mini-delete" @click="removeDamage(index)">✕</button>
            </div>
            <div v-if="!damagesList.length" class="empty-row">No hay daños registrados.</div>
          </div>
        </div>
        </div>

        <div class="maintenance-side">
          <div class="container-card">
            <div class="title">
              <h4>Deductibles</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Daño material:</label>
                <input type="number" min="0" v-model.number="form.material_damage" />
              </div>
              <div class="form-input-group">
                <label>Resp. civil:</label>
                <input type="number" min="0" v-model.number="form.civil_liability" />
              </div>
              <div class="form-input-group">
                <label>Resp. limitada:</label>
                <input type="number" min="0" v-model.number="form.limited_liability" />
              </div>
              <div class="form-input-group full-width">
                <label>Comentarios deducible:</label>
                <textarea v-model="form.deductible_comments"></textarea>
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Daños</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Daño estimado:</label>
                <input type="number" min="0" v-model.number="form.estimated_damage" />
              </div>
              <div class="form-input-group">
                <label>Daño real:</label>
                <input type="number" min="0" v-model.number="form.real_damage" />
              </div>
              <div class="form-input-group">
                <label>Veredicto:</label>
                <input type="text" v-model="form.veredict" />
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Resolución</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Tiempo de resolución:</label>
                <input type="datetime-local" v-model="form.resolution_time" />
              </div>
              <div class="form-input-group">
                <label>Quién resolvió:</label>
                <input type="text" v-model="form.who_resolved" />
              </div>
              <div class="form-input-group full-width">
                <label>Resolución:</label>
                <textarea v-model="form.resolution_description"></textarea>
              </div>
              <div class="form-input-group full-width">
                <label>Comentarios resolución:</label>
                <textarea v-model="form.resolution_comments"></textarea>
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Datos del sistema</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Capturista:</label>
                <input type="text" :value="currentUserName" disabled />
              </div>
              <div class="form-input-group">
                <label>Solicitud:</label>
                <input type="datetime-local" :value="formatDatetime(createdAt)" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions" style="min-width: 1200px;">
        <button
          v-if="canCreateIncident"
          type="button"
          class="btn-submit-save"
          @click="saveIncident"
          :disabled="saving"
        >
          {{ saving ? 'Guardando...' : 'Guardar' }}
        </button>
        <button type="button" class="btn-submit-cancel" @click="backIncidents">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'NewIncident',
  data() {
    return {
      permissions: [],
      form: {
        unit: '',
        company: '',
        operator: '',
        signed_off_by: '',
        incident_address: '',
        repair_order_number: '',
        accident_type: '',
        accident_description: '',
        division: '',
        material_damage: '',
        civil_liability: '',
        limited_liability: '',
        deductible_comments: '',
        estimated_damage: '',
        real_damage: '',
        who_paid: '',
        affected_person_name: '',
        affected_person_phone: '',
        affected_person_email: '',
        affected_person_address: '',
        resolution_time: '',
        resolution_description: '',
        resolution_comments: '',
        who_resolved: '',
        veredict: '',
      },
      authorities: [{ authority: '', comments: '' }],
      damagesList: [{ type: '', comments: '' }],
      validationErrors: {
        unit: false,
        accident_description: false,
      },
      employees: [],
      operatorEmployees: [],
      units: [],
      owners: [],
      saving: false,
      employeeid: '',
      currentUserDisplay: '',
      createdAt: '',
    }
  },
  computed: {
    canCreateIncident() {
      return this.hasAnyPerm(['maintenance.create_incident', 'ui_access_maintenance_incidents_card'])
    },
    currentUserName() {
      if (this.currentUserDisplay) return this.currentUserDisplay
      const id = this.employeeid ? Number(this.employeeid) : null
      const emp = this.employees.find((item) => item.id === id || item.employee_id === id || item.employee_ident === id)
      if (!emp) return this.employeeid ? `Empleado ${this.employeeid}` : 'N/A'
      return `${emp.employee_first_name} ${emp.employee_last_name}`.trim()
    },
  },
  mounted() {
    this.loadPermissions()
    if (!this.canCreateIncident) {
      this.$router.push({ name: 'MainPanel' })
      return
    }
    this.createdAt = new Date().toISOString()
    this.fetchCurrentUser()
    this.fetchEmployees()
    this.fetchOperatorEmployees()
    this.fetchUnits()
    this.fetchOwners()
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    backMainPanel() {
      this.$router.push('/main-panel')
    },
    backIncidents() {
      this.$router.push('/unit-incidents')
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: `Token ${localStorage.getItem('authToken')}` },
        })
        const data = response.data || {}
        this.employeeid =
          Number(data.employee_id || data.employee?.id || data.employee || data.employeeid || data.id || 0) || ''
        this.currentUserDisplay =
          data.employee_name ||
          data.employee_full_name ||
          data.full_name ||
          (data.employee_first_name && data.employee_last_name
            ? `${data.employee_first_name} ${data.employee_last_name}`.trim()
            : '') ||
          data.name ||
          ''
      } catch (error) {
        console.error('There was an error fetching the user data:', error)
      }
    },
    async fetchEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.post(`${apiDirectory}/get-employee?page=1&page_size=200`, {})
        this.employees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching employees:', error)
      }
    },
    async fetchOperatorEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/operators-for-forms`)
        this.operatorEmployees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching operator employees:', error)
      }
    },
    async fetchUnits() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/units-for-forms`)
        this.units = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching units:', error)
      }
    },
    async fetchOwners() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/get-owners`)
        this.owners = response.data || []
      } catch (error) {
        console.error('There was an error fetching owners:', error)
      }
    },
    formatDatetime(value) {
      if (!value) return ''
      return value.slice(0, 16)
    },
    addAuthority() {
      this.authorities.push({ authority: '', comments: '' })
    },
    removeAuthority(index) {
      this.authorities.splice(index, 1)
      if (!this.authorities.length) {
        this.authorities.push({ authority: '', comments: '' })
      }
    },
    addDamage() {
      this.damagesList.push({ type: '', comments: '' })
    },
    removeDamage(index) {
      this.damagesList.splice(index, 1)
      if (!this.damagesList.length) {
        this.damagesList.push({ type: '', comments: '' })
      }
    },
    sanitizeList(list, keys) {
      const cleaned = list
        .map((item) => {
          const trimmed = {}
          keys.forEach((key) => {
            trimmed[key] = (item[key] || '').toString().trim()
          })
          return trimmed
        })
        .filter((item) => keys.some((key) => item[key]))
      return cleaned.length ? cleaned : null
    },
    validateForm() {
      this.validationErrors.unit = !this.form.unit
      this.validationErrors.accident_description = !this.form.accident_description
      return !this.validationErrors.unit && !this.validationErrors.accident_description
    },
    async saveIncident() {
      if (!this.canCreateIncident) {
        Swal.fire('Sin acceso', 'No tienes permisos para crear incidencias.', 'warning')
        return
      }
      if (!this.validateForm()) {
        await Swal.fire('Faltan datos', 'Completa los campos obligatorios.', 'warning')
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      try {
        this.saving = true
        const numberResponse = await axios.post(`${apiDirectory}/calculate-unit-incident-number`)
        const incidentNumber = numberResponse.data
        const payload = {
          ...this.form,
          incident_number: incidentNumber,
          data_entry_clerk: this.employeeid,
          incident_status: 1,
          request_time: this.createdAt || new Date().toISOString(),
          resolution_time: this.form.resolution_time || null,
          authorities_involved: this.sanitizeList(this.authorities, ['authority', 'comments']),
          damages: this.sanitizeList(this.damagesList, ['type', 'comments']),
        }
        await axios.post(`${apiDirectory}/create-unit-incident`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          background: '#d4edda',
          title: '¡Guardado!',
          text: 'La incidencia se guardó correctamente.',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        })
        this.$router.push('/unit-incidents')
      } catch (error) {
        console.error('There was an error saving incident', error)
        Swal.fire('Error', error.message || 'No se pudo guardar la incidencia.', 'error')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
/* Uses maintenance order styles */
.logo-button { height: 40px; }
.nav-bar-operations { height: 50px; }
.note-container { padding: 0 15px; }
.create-order { display: flex; padding: 5px 0; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap; }
.create-order button { padding: 5px 15px; background-color: #d5171d; color: white; border: none; border-radius: 7px; cursor: pointer; font-size: 14px; font-weight: 500; transition: .3s all; }
.create-order button:hover { background: black; }
.main-data-container { display: grid; grid-template-columns: repeat(14, minmax(0, 1fr)); gap: 12px; margin-top: 12px; }
.container-card { border: 1px solid #f3f3f3; border-radius: 0px; margin-bottom: 0px; border-top: none; }
.container-card-body { padding: 5px 8px; }
.title { background: #f2f7fa; padding: 5px 15px; border-radius: 0; display: flex; align-items: center; gap: 10px; }
.title h4 { font-size: 16px; text-align: left; line-height: 20px; margin-bottom: 0; font-weight: 700; }
.maintenance-title-row { justify-content: space-between; }
.maintenance-general { grid-column: span 10; }
.maintenance-side { grid-column: span 4; display: grid; gap: 12px; }
.maintenance-general-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 16px; }
.maintenance-column { display: grid; gap: 8px; }
.maintenance-main { grid-column: span 10; display: grid; gap: 12px; }
.form-input-group { display: flex; align-items: center; gap: 8px; }
.form-input-group label { min-width: 110px; margin: 0; }
.form-input-group.full-width { margin-top: 8px; }
input[type=text], input[type=number], input[type=datetime-local], select, textarea { padding: 1.5px 8px; width: 100%; font-size: 11px; border: 1px solid #ececec; border-radius: 5px; font-weight: 500; outline: none; margin-bottom: 0; }
input[type=text]:focus, input[type=number]:focus, input[type=datetime-local]:focus, select:focus, textarea:focus { border: 1px solid #ffc736; }
.form-input-group input, .form-input-group select, .form-input-group textarea { flex: 1; }
label { display: block; font-size: 11px; margin-bottom: 0; font-weight: 600; color: #929292; }
.form-input-group label { margin-top: 2px; }
textarea { min-height: 64px; resize: vertical; }
.invalid { border-color: #d9534f !important; background: #fff3f3; }
.form-actions { display: flex; justify-content: center; gap: 8px; padding: 12px 0 16px; }
.btn-submit-save { background-color: #2ada85; color: #fff; border: none; padding: 4px 12px; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 600; }
.btn-submit-cancel { background-color: #d5171d; color: #fff; border: none; padding: 4px 12px; border-radius: 6px; font-size: 12px; cursor: pointer; }
.mini-action {
  border: 1px solid #ececec;
  background: #111827;
  color: #fff;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 11px;
  cursor: pointer;
}
.list-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f3f3f3;
}
.list-row:last-child { border-bottom: none; }
.mini-delete {
  border: none;
  background: #d5171d;
  color: #fff;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
}
.empty-row {
  font-size: 12px;
  color: #8a8a8a;
  padding: 6px 0;
}
</style>
